import { Chart } from 'chart.js';
import { useLayoutEffect } from 'react';
import { getFontScale } from 'src/common/utils/fonts';

export const useChartDefaultFontSize = () => {
  useLayoutEffect(() => {
    const updateSize = () => {
      Chart.defaults.font.size = 12 * getFontScale();
    };

    globalThis.addEventListener('resize', updateSize);
    updateSize();
    return () => globalThis.removeEventListener('resize', updateSize);
  }, []);
};
